module.exports = __webpack_public_path__ + "media/แบลบๆ.4a6eb5bf.mp3";